module.exports = __webpack_public_path__ + "img/5_36.36636bd6.png";